import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Box, Toolbar } from '@mui/material';

// project import
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import HorizontalBar from './Drawer/HorizontalBar';
import Loader from 'components/Loader';
import Breadcrumbs from 'components/@extended/Breadcrumbs';

import AuthGuard from 'utils/route-guard/AuthGuard';

import useConfig from 'hooks/useConfig';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { DRAWER_WIDTH, MenuOrientation } from 'config';
import useNotificationsPoller from 'contexts/notifications/useNotificationsPoller';

// ==============================|| MAIN LAYOUT ||============================== //

const DashboardLayout = () => {
  const theme = useTheme();
  const { menuMasterLoading } = useGetMenuMaster();
  useNotificationsPoller();
  const matchDownXL = useMediaQuery(theme.breakpoints.down('xl'));
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));

  const { miniDrawer, menuOrientation } = useConfig();

  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  // Check if in development mode to add top padding for warning bar
  const isProduction = (process.env.REACT_APP_PRODUCTION || '').toUpperCase() === 'TRUE';




  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      handlerDrawerOpen(!matchDownXL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownXL]);



  
  if (menuMasterLoading) return <Loader />;





  return (
    <AuthGuard>
      <Box 
        sx={{ 
          display: 'flex', 
          width: '100%',
          paddingTop: isProduction ? 0 : '20px' // Add top padding for development warning bar
        }}
      >
        <Header />
        {!isHorizontal ? <Drawer /> : <HorizontalBar />}

        <Box
          component='main'
          sx={{
            // Use the real drawer width and allow the flex item to shrink below
            // its content's min-content size so wide tables scroll internally
            // instead of overflowing the viewport.
            width: `calc(100% - ${DRAWER_WIDTH}px)`,
            minWidth: 0,
            flexGrow: 1,
            p: 0,
          }}
        >
          <Toolbar sx={{ mt: isHorizontal ? 8 : 'inherit' }} />
          <Breadcrumbs />
          <Outlet />
          <Footer />
        </Box>
      </Box>
    </AuthGuard>
  );
};

export default DashboardLayout;
